{
  "actions": {
    "back": "Back",
    "close": "Close",
    "minimize": "Minimize",
    "maximize": "Maximize",
    "restore": "Restore"
  },
  "home": {
    "title": "Home",
    "role": "Product Designer & Developer",
    "role_pdf": "Designer & Developer",
    "pitch": "I make complicated digital products understandable and useful. I see where a flow gets stuck, ask the right questions, and keep building until it works for people and the technology behind it.",
    "skills": {
      "product_design": "Product Design",
      "ux_research": "UX Research",
      "frontend": "Frontend Development",
      "websites_apps": "Websites & Apps",
      "design_systems": "Design Systems",
      "ai_workflows": "AI Workflows"
    },
    "available": "Available for projects and permanent roles",
    "cta_work": "View my work",
    "cta_contact": "Get in touch"
  },
  "work": {
    "title": "Work",
    "heading": "Selected Work",
    "filters": {
      "all": "All",
      "apps": "Applications",
      "video": "AI Video",
      "design": "Design"
    },
    "back": "Back",
    "role": "Role",
    "tech": "Technology",
    "results": "Results",
    "intention": "Intent",
    "process": "Process",
    "outcome": "Outcome",
    "gallery": "Gallery",
    "view_case": "View case study",
    "cta_title": "Recognise this in your product?",
    "cta_button": "Let's compare notes"
  },
  "about": {
    "title": "About",
    "heading": "The full picture",
    "intro": "I turn vague ideas and disconnected systems into products people can understand. When something is unnecessarily complex, I want to know where it gets stuck and make it workable.",
    "approach_title": "How I work",
    "approach": "I start with what someone actually needs to do. Then I remove distractions, make something tangible quickly, and test whether the logic works. Design and technology do not belong in separate boxes.",
    "capabilities_title": "My path & focus",
    "capabilities": {
      "ux": "UX as a foundation (since 2018) — Starting with the user. How do people think? Where do they drop off? What feels logical?",
      "tech": "Technical insight — Frontend development to understand exactly how things are built, ensuring design and engineering perfectly align.",
      "ai": "AI as an accelerator — I do not use AI as a gimmick, but to explore, prototype, and improve workflows faster. From prompt engineering to integrations that solve a real problem.",
      "now": "Broad by nature — From websites and apps to wireframes, mockups, and dashboards. I do the groundwork, make ideas concrete, and keep building until it works for the end user.",
      "drive": "What drives me — Systems others would rather avoid. I figure out how they work, build a first version, and keep refining until it clicks."
    }
  },
  "resume": {
    "title": "Resume",
    "download": "Download Resume (.pdf)",
    "experience": "Experience",
    "education": "Education",
    "skills": "Skills",
    "learning": "Continuous learning",
    "learning_practice_title": "I learn by building",
    "learning_focus": "I learn fastest by making something. I try new AI tools and frameworks in my own projects, see where they break, then keep building until I know what actually works.",
    "projects": "Selected project",
    "project_meester_title": "Meester djay",
    "project_meester_subtitle": "Adaptive learning platform for grades 6–8",
    "project_meester_meta": "Independent product project / Current",
    "project_meester_description": "Developed an adaptive learning platform with a mastery-based engine, multi-role portals, and AI-assisted engineering - from learning experience and UX to technical architecture.",
    "project_meester_capability": "From concept and UX to adaptive logic, content validation, and technical architecture.",
    "project_meester_metric_subjects": "10 subject areas",
    "project_meester_metric_questions": "263 question families",
    "project_meester_metric_levels": "16 difficulty tiers",
    "freelance_role": "Freelance Product Designer & Developer",
    "freelance_company": "MvlCreative — Almere",
    "freelance_period": "2021 — Present",
    "freelance_description": "Designing and building digital products that make complex processes clear and intuitive. From UX strategy and design systems to frontend development, LLM integrations, and AI workflows.",
    "webheld_role": "Web Developer",
    "webheld_company": "Webheld — Baarn",
    "webheld_period": "2020 — 2021",
    "webheld_description": "Built and optimized WordPress and Magento websites and webshops, with a focus on reliable delivery, technical quality, SEO, and user-friendly interfaces.",
    "aim_role": "Web Developer",
    "aim_company": "Aim — Badhoevedorp",
    "aim_period": "2020",
    "aim_description": "Delivered websites from design through launch and evolved WordPress environments into consistent, maintainable digital foundations.",
    "tweak_role": "Service Desk",
    "tweak_company": "Tweak — Almere",
    "tweak_period": "2019 — 2020",
    "tweak_description": "Turned technical customer questions into clear solutions through analysis, troubleshooting, and diligent follow-up, with a focus on a positive user experience.",
    "more_coming": "More experience will be added soon."
  },
  "contact": {
    "title": "Contact",
    "heading": "Let's get acquainted",
    "phone_label": "Phone",
    "location": "Almere, Netherlands",
    "location_label": "Location",
    "availability": "Netherlands + remote. Open to projects and permanent roles.",
    "status": "Open to projects and permanent roles",
    "cta_call": "Schedule a video call",
    "social_label": "Social",
    "status_label": "Status"
  },
  "boot": {
    "loading": "Loading creativity...",
    "design_systems": "Initializing design systems...",
    "connecting_ai": "Connecting AI...",
    "ready": "Ready."
  },
  "command": {
    "placeholder": "Search or navigate...",
    "projects": "Projects",
    "navigation": "Navigation",
    "settings": "Settings"
  }
}